import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=e9086fa4&"
import script from "./ProductIntro.vue?vue&type=script&lang=js&"
export * from "./ProductIntro.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports